import { render, staticRenderFns } from "./tz.vue?vue&type=template&id=49952d7e&scoped=true&"
import script from "./tz.vue?vue&type=script&lang=js&"
export * from "./tz.vue?vue&type=script&lang=js&"
import style0 from "./tz.vue?vue&type=style&index=0&id=49952d7e&prod&lang=scss&scoped=true&"
import style1 from "./tz.vue?vue&type=style&index=1&id=49952d7e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49952d7e",
  null
  
)

export default component.exports